import React from 'react';
import { useTranslation } from 'react-i18next';
import sanitizeHtml from 'sanitize-html';
import CreditsIcon from '@src/assets/icons/credits-icon.svg';
import CreditUsageGuide from './CreditUsageGuide';
import { StyledContent, StyledBanner } from './index.style';

const SANITIZE_OPTIONS = {
  allowedTags: ['b', 'br'],
};

const NewCreditIntroContent = ({ isMobile }) => {
  const { t } = useTranslation();

  const renderDesktopParagraphs = () => (
    <>
      <p
        className="banner-paragraph"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(
            t('newCreditIntroBannerParagraph1'),
            SANITIZE_OPTIONS,
          ),
        }}
      />
      <p
        className="banner-paragraph banner-paragraph--emphasis"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(
            t('newCreditIntroBannerParagraph2'),
            SANITIZE_OPTIONS,
          ),
        }}
      />
    </>
  );

  const renderMobileParagraph = () => {
    const paragraph1 = t('newCreditIntroBannerParagraph1');
    const paragraph2 = t('newCreditIntroBannerParagraph2').replace(
      /<br\s*\/?>/gi,
      ' ',
    );
    const combined = `${paragraph1} ${paragraph2}`;

    return (
      <p
        className="banner-paragraph banner-paragraph--emphasis"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(combined, SANITIZE_OPTIONS),
        }}
      />
    );
  };

  return (
    <StyledContent $isMobile={isMobile}>
      <StyledBanner $isMobile={isMobile}>
        <div className="banner-text-container">
          {isMobile && (
            <img src={CreditsIcon} alt="credits" className="banner-sparkle" />
          )}
          <div className="banner-text-column">
            <p className="banner-title">{t('newCreditIntroBannerTitle')}</p>
            {isMobile ? renderMobileParagraph() : renderDesktopParagraphs()}
          </div>
        </div>
      </StyledBanner>

      <CreditUsageGuide isMobile={isMobile} showTitle={false} />
    </StyledContent>
  );
};

export default NewCreditIntroContent;
